import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import {
  startProjectService,
  updateProjectStatusService,
  getProjectFileService,
} from 'services/projects'
import { useCountryCode } from 'querys/payment'
import { useProjectKey } from 'querys/projects'
import useSession from 'querys/session'

export function useStartProject() {
  const [downloading, setDownloading] = useState(false)
  const [downloaded, setDownloaded] = useState(false)
  const [progress, setProgress] = useState(0)
  const queryClient = useQueryClient()
  const PROJECT_KEY = useProjectKey()
  const [key, project, token] = PROJECT_KEY
  const mutation = useMutation(
    () => startProjectService({
      project,
      token,
    }),
    {
      onMutate: () => {
        setDownloading(true)
      },
      onSuccess: async (projectIniciated) => {
        queryClient.setQueryData(PROJECT_KEY, (projectData) => ({ ...projectData, progress_status: projectIniciated }))
        await getProjectFileService({ slug: project, token, setProgress })
        setDownloaded(true)
        setDownloading(false)
      },
      onError: () => {
        setDownloading(false)
        setProgress(0)
      },
    },
  )
  return {
    ...mutation,
    downloading,
    progress,
    setProgress,
    downloaded,
    setDownloading,
    setDownloaded,
  }
}

export function handleUpdate({
  project, project_url, repository_slug, stack, mutation, description,
}) {
  const formData = new FormData()
  formData.append('project_url', project_url)
  formData.append('repository_slug', repository_slug)
  formData.append('description', description)
  stack.forEach((item) => {
    formData.append('stack', item)
  })
  mutation({
    project,
    payload: formData,
  })
}

export function useUpdateProjectStatus() {
  const queryClient = useQueryClient()
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [success, setSuccess] = useState(false)
  const { token } = useSession()
  const { data: { countryCode } } = useCountryCode()

  const mutation = useMutation(
    ({ project, payload }) => updateProjectStatusService({
      project,
      payload,
      token,
    }),
    {
      onSuccess: (data, { project }) => {
        setError(false)
        setSuccess(true)
        queryClient.setQueryData('GET_PROFILE', (profileData) => {
          const projectsUpdated = profileData.projects.map((item) => {
            if (item.slug === project) {
              return { ...item, progress_status: data }
            }
            return item
          })
          return { ...profileData, projects: projectsUpdated }
        })
        queryClient.setQueryData(['GET_PROJECT', project, token, countryCode], (projectData) => {
          if (projectData) return { ...projectData, progress_status: data }
          return { progress_status: data }
        })
      },
      onError: (e) => {
        if (e.cause.message.includes('"slug" válido')) {
          setErrorMessage('Por favor cambia el nombre tu repositorio a uno válido consistente en letras, números, guiones o guiones bajos.')
        }
        if (e.message === 'max_length') {
          setErrorMessage('Asegurate de que la descripción no tenga más de 250 caracteres.')
        }
        if (e.message === 'url_already_used') {
          setErrorMessage('El repositorio o tu url del website ya ha sido asignada a otro proyecto.')
        }
        setError(true)
        setSuccess(false)
        setTimeout(() => {
          setError(false)
        }, 8000)
      },
    },
  )
  return {
    ...mutation,
    error,
    errorMessage,
    success,
    setError,
  }
}
